export default __webpack_public_path__ + "static/media/hamburger-button.a5b3558c.svg";